import React, { type ReactNode } from 'react';
import { FiltersContainer } from '@atlassian/jira-software-backlog-filters-store/src/controllers/filters-container/index.tsx';
import type { Filters } from '../../model/filters/types.tsx';
import { setAllFilters } from '../../state/actions/filters/index.tsx';
import { useBacklogActionCreator, useBacklogSelector } from '../../state/index.tsx';
import { getIsCompanyManaged } from '../../state/selectors/app/index.tsx';
import { isVersionsFeatureEnabled as isVersionsFeatureEnabledSelector } from '../../state/selectors/version/index.tsx';
import { VersionPanelEntrypointContextProvider } from './version-panel/index.tsx';

type Props = {
	boardId: number;
	children: ReactNode;
};

// register root level data-providers here
const View = (props: Props) => {
	const { children, boardId } = props;
	const isCompanyManaged = useBacklogSelector(getIsCompanyManaged);
	const isVersionsFeatureEnabled = useBacklogSelector(isVersionsFeatureEnabledSelector);
	const onFiltersChange = useBacklogActionCreator((filters: Filters) => setAllFilters(filters));

	// onSetAllFilters is a redux action fired to sync filters
	return (
		<FiltersContainer
			boardId={boardId}
			onFiltersChange={onFiltersChange}
			isVersionsFeatureEnabled={isCompanyManaged || isVersionsFeatureEnabled}
			isCompanyManaged={isCompanyManaged}
		>
			<VersionPanelEntrypointContextProvider>{children}</VersionPanelEntrypointContextProvider>
		</FiltersContainer>
	);
};

export default View;
